import { Icon, LinkButton } from "@ttc3k/trekker";
import { BookerByIdQuery } from "gql/generated";
import { Download, Eye } from "iconoir-react";
import { useTranslation } from "react-i18next";
import { getCloudinary } from "shared/cloudinary";
import { Flex } from "styled-system/jsx";
import { ReservationSection } from "./ReservationSection";

type WaiversProps = {
  waivers: NonNullable<BookerByIdQuery["bookerById"]>["waivers"];
};

export const Waivers = ({ waivers }: WaiversProps) => {
  const { t } = useTranslation("storefront", {
    keyPrefix: "RESERVATION_DETAILS.WAIVERS",
  });

  // Download the waiver from cloudinary
  const handleDownload = async (
    waiver: NonNullable<
      NonNullable<BookerByIdQuery["bookerById"]>["waivers"]
    >[0],
  ) => {
    const cloudinaryImage = getCloudinary(waiver._id).image(waiver._id);
    const waiverUrl = cloudinaryImage.toURL();

    try {
      if (!waiverUrl) return;

      const response = await fetch(waiverUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = waiver.caption.en ?? "download";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(waiverUrl);
    } catch (error) {
      console.error("Download error", error);
    }
  };

  if (!waivers || waivers.length === 0) return null;

  return (
    <ReservationSection
      icon={Eye}
      title={t("TITLE")}
      description={t("DESCRIPTION")}
    >
      <Flex flexDir="column" gap="100">
        {waivers.map(waiver => {
          return (
            <LinkButton
              key={waiver._id}
              onClick={() => handleDownload(waiver)}
              w="fit-content"
              display="flex"
              alignItems="center"
              gap="50"
            >
              {waiver.caption.en}
              <Icon Element={Download} w="20px" h="20px" />
            </LinkButton>
          );
        })}
      </Flex>
    </ReservationSection>
  );
};
